import store from '@/store/store';
import { browseDetailClient } from '@/api/clients/index';
import { trouverMandatActif, dateAvantProchainMandatActif } from '@/services/gestionPanneau/trouverMandatActif';
import genererModeCalculHonoraire from '@/services/devis/genererModeCalculHonoaire';
import { MANDATAIRE_PAYEUR } from '@/services/societe/societe';
import { SET_POINT_DE_VENTE } from '@/store/modules/recommandations-mutation-type';
import { getInfoHavasCalculHonoraire } from '@/api/devisCommandeFacture/index';
import { updateAll, createAll } from '@/api/mandatTiers/index';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import gestionErreur from '@/services/general/gestionErreur';
import formatIsoDate from '@/services/general/formatIsoDate';
import genererMandat from '@/services/mandat/genererMandat';
import { preparationEnvoiBackMandat } from '@/services/mandat/preparationEnvoiBackMandat';

function modeCalculHonoraireADiverge(actuel, cible) {
  return actuel.modeCalcul !== cible.modeCalcul
    || actuel.pourcentage !== cible.pourcentage
    || actuel.montantHonoraireFraisTraitement !== cible.montantHonoraireFraisTraitement
    || actuel.applicableSurDivers !== cible.applicableSurDivers;
}

function setModeCalculHonoraire(budget, modeCalcul) {
  if (!budget || !budget.modeCalculHonoraire.creation) return;
  budget.modeCalculHonoraire = { ...modeCalcul };
  const honoraireForfaitaire = store.getters['recommandations/honoraireForfaitaire'];
  const { montantHonoraireForfaitaire } = modeCalcul;

  if (!honoraireForfaitaire && montantHonoraireForfaitaire) {
    store.dispatch('recommandations/setLigneHonoraireForfaitaire', montantHonoraireForfaitaire);
  }
}

export default async function updateModeCalculHonoraireLigneCommandeHonoraire(budget, contexte = null) {
  const pointDeVente = store.getters['recommandations/pointDeVente'];
  if (!pointDeVente || !pointDeVente.tiersParentId) {
    return;
  }
  const enseigne = contexte && contexte.enseigne
    ? contexte.enseigne
    : (await browseDetailClient(pointDeVente.tiersParentId)).data;

  if (!enseigne) {
    return;
  }

  const dateDebutBudget = budget.dateDebut
    ? new Date(budget.dateDebut)
    : new Date();

  const clientPourRecherche = {
    nomCommercial: pointDeVente.nomCommercial,
    id: pointDeVente.id,
    mandats: pointDeVente.mandats || [],
    tiersParent: {
      id: enseigne.id,
      mandats: enseigne.mandats || [],
    },
  };
  let mandat = await trouverMandatActif(clientPourRecherche, dateDebutBudget);
  let modeCalcul;
  let roleVendeur;
  let infoCalcul = contexte ? contexte.infoCalculHavas : null;
  if (!contexte && pointDeVente.id && pointDeVente.referenceHavas) {
    try {
      infoCalcul = (await getInfoHavasCalculHonoraire(pointDeVente.id)).data.result;
    } catch (error) {
      infoCalcul = null;
      gestionErreur('Echec de récupération des honoraires Havas', error);
    }
  }

  if (!mandat && infoCalcul) {
    mandat = genererMandat();
    mandat.modeCalculHonoraire.modeCalcul = tiersConf.MODE_CALCUL_MULTIPLE;
    mandat.dateDebut = formatIsoDate(dateDebutBudget);
    mandat.dateFin = dateAvantProchainMandatActif(clientPourRecherche, dateDebutBudget);
    mandat.role = MANDATAIRE_PAYEUR;
    mandat.tiersId = pointDeVente.id;
  }
  if (mandat) {
    modeCalcul = { ...mandat.modeCalculHonoraire };
    roleVendeur = mandat.role;
    if (modeCalcul.modeCalcul !== tiersConf.MODE_CALCUL_MANUEL ) {
      if (infoCalcul) {
        modeCalcul.modeCalcul = tiersConf.MODE_CALCUL_MULTIPLE;
        modeCalcul.pourcentage = infoCalcul.tauxhonosEspace;
        modeCalcul.montantHonoraireFraisTraitement = infoCalcul.tauxHonosFraisTraitement;
        modeCalcul.applicableSurDivers = infoCalcul.tauxHonosFraisTech !== 0;
        modeCalcul.applicableSurLocation = true;
        if (modeCalculHonoraireADiverge(mandat.modeCalculHonoraire, modeCalcul)) {
          try {
            if (mandat.id) {
              await updateAll([
                preparationEnvoiBackMandat({ ...mandat, modeCalculHonoraire: modeCalcul }),
              ]);
            } else {
              const mandatsExistants = pointDeVente.mandats || [];
              const mandatsCreate = (await createAll([preparationEnvoiBackMandat(mandat)])).data.result;
              pointDeVente.mandats = [...mandatsExistants, ...mandatsCreate];
              store.commit('recommandations/' + SET_POINT_DE_VENTE, pointDeVente);
            }
            mandat.modeCalculHonoraire = modeCalcul;
          } catch (error) {
            gestionErreur('Echec de mise à jour du mandat (honoraires Havas)', error);
          }
        }
      }
    }
  } else {
    modeCalcul = genererModeCalculHonoraire();
    roleVendeur = MANDATAIRE_PAYEUR;
  }

  budget.roleVendeur = roleVendeur;

  setModeCalculHonoraire(budget, modeCalcul);
}
